import Vue from "vue";
import axios from 'axios'
import router from "./router";
import request from './request'
import {getStore} from "./store"
import {getToken, setToken} from "./utils/auth";
import listToTree from './utils/listToTree'
import {Dialog} from "element-ui";


export default class cloud {
    static router = null;
    static app = null

    constructor(object) {
        if (object.debug) {
            window.__DEBUG__ = true;
        } else {
            window.__DEBUG__ = false;
        }
        window.$cloud = Vue.prototype.$cloud = cloud;
        object['router'] = cloud.router = router(object.router);
        cloud.app = new Vue(object).$mount('#app');
        return cloud.app;
    }

    /**
     * 获取Token
     * @param value
     * @returns {*}
     */
    static token(value = null) {
        if (value) {
            setToken(value)
        } else {
            return getToken()
        }
    }


    static prefix() {
        return {};
    }

    /**
     * 数据GET方法
     * @param url
     * @param params
     * @returns {*}
     */
    static get(url, params = null) {
        if (url.indexOf("/") === 0) {
            url = url.slice(1)
        }
        //重置URL地址
        url = `/api/` + url;
        return request({
            url: url,
            method: 'GET',
            headers: {
                'x-api-type': 'app'
            },
            params: Object.assign(cloud.prefix(), params),
        })
    }

    /**
     * 创建POST
     * @param url
     * @param params
     * @param data
     * @returns {*}
     */
    static post(url, params = null, data = null) {
        if (url.indexOf("/") === 0) {
            url = url.slice(1)
        }
        //设置数据结构
        if (data === null) {
            data = params;
            params = null
        }
        //重置URL地址
        url = `/api/` + url;
        return request({
            url: url,
            method: 'POST',
            headers: {
                'x-api-type': 'app'
            },
            params: Object.assign(cloud.prefix(), params),
            data: data
        })
    }

    /**
     * 创建POST
     * @param url
     * @param method
     * @param data
     * @returns {*}
     */
    static http(url, method = 'POST', data = null) {
        return request({
            url: url,
            method: method,
            headers: {
                'x-api-type': 'app'
            },
            data: data
        })
    }

    /**
     * 判断是否登录
     * @returns {*}
     */
    static isLogin() {
        return getStore().isLogin()
    }

    static userInfo() {
        return getStore().userInfo()
    }

    /**
     * 登录方法
     */
    static login() {
        return new Promise((resolve, reject) => {
            getStore().dispatch('login', () => {
                return cloud.post.apply(cloud, Array.from(arguments))
            }).then(data => {
                resolve(data)
            }).catch(error => {
                reject(error);
            })
        })
    }

    static logout() {
        return new Promise((resolve, reject) => {
            getStore().dispatch('logout').then(data => {
                resolve(data)
            }).catch(error => {
                reject(error);
            })
        })
    }

    /**
     * 跳转
     */
    static go(url, query = null) {
        if (Object.prototype.toString.call(url) === "[object Object]") {
            if (url.query) {
                url.query = Object.assign(url.query, query);
            }
        } else {
            url = {
                path: url,
                query
            }
        }
        cloud.router.push(url);
    }

    /**
     * 执行弹窗
     */
    static dialog({
                      title = "",
                      component = "",
                      data = {},
                      customClass = null,
                      refresh = null,
                      success = '保存成功',
                      warning = '保存失败'
                  }) {
        let {$createElement} = cloud.app;
        console.log(" cloud.app", $createElement)
        const key = 'qn_' + (new Date().getTime());
        const vNode = $createElement(component, {
            key: key,
            props: {
                value: JSON.parse(JSON.stringify(data))
            },
        });
        const dialog = $createElement(Dialog, {})

        console.log("dialog", dialog)
    }

    /**
     * 创建POST
     * @param url
     * @param params
     * @param data
     * @returns {*}
     */
    static upload(url, params = null, data = null, config = {}) {
        if (url.indexOf("/") === 0) {
            url = url.slice(1)
        }
        //设置数据结构
        if (data === null) {
            data = params;
            params = null
        }
        //判断是否是表单数据
        if (params instanceof FormData) {
            //判断如果data数据存在的情况则赋值给config
            if (data) {
                config = data;
            }
            //没有params传参，直接是文件类
            data = params;
        }

        //重置URL地址
        url = `/api/` + url;
        return request({
            url: url,
            method: 'POST',
            headers: {
                "Content-type": "multipart/form-data",
                "x-api-type": "app"
            },
            ...config,
            params: Object.assign(cloud.prefix(), params),
            data: data
        })
    }

    /**
     * cancelToken
     * @param fun
     * @returns {CancelToken}
     */
    static cancelToken(fun) {
        return new axios.CancelToken(fun)
    }

    /**
     * 处理树结构
     * @param options
     * @returns {listToTree}
     */
    toTree(options) {
        return new listToTree(options);
    }

    /**
     * 转json
     * @return {string}       [description]
     * @param value
     */
    toJson(value) {
        return JSON.stringify(value).toString();
    };

    /**
     * json转数组
     * @return {[type]}       [description]
     * @param value
     */
    toArray(value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null
        }
    };
}